export default {"src":"/_next/static/media/phone.b52660a5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};